import { render, staticRenderFns } from "./BasePanelForm1.vue?vue&type=template&id=4997e1d6&scoped=true"
import script from "./BasePanelForm1.vue?vue&type=script&lang=js"
export * from "./BasePanelForm1.vue?vue&type=script&lang=js"
import style0 from "./BasePanelForm1.vue?vue&type=style&index=0&id=4997e1d6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4997e1d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4997e1d6')) {
      api.createRecord('4997e1d6', component.options)
    } else {
      api.reload('4997e1d6', component.options)
    }
    module.hot.accept("./BasePanelForm1.vue?vue&type=template&id=4997e1d6&scoped=true", function () {
      api.rerender('4997e1d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/panel/BasePanelForm1.vue"
export default component.exports